module.exports = __webpack_public_path__ + "static/media/payments.0cf3cd64.svg";